import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * A reusable button component that provides a standardized button with various customization options.
 * @class ButtonComponent
 */
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,

  imports: [CommonModule],
})
export class ButtonComponent {
  /** Button text content */
  @Input() text = '';

  @Input() btnType: 'sura-btn' | 'btn' = 'sura-btn';
  /** Button type (primary, alter, etc.) */
  @Input() type: 'primary' | 'alter' | 'disabled' | 'btn-primary' = 'primary';

  /** Button size (medium, small, large) */
  @Input() size: 'medium' | 'small' | 'large' = 'large';

  /** Button width (fullwidth, no-witch) */
  @Input() witch: '' | 'fullwidth' | 'w-100' | 'w-50' | 'w-75' = '';

  /** Button shape (rounded, square) */
  @Input() alter: '' | 'alter' = '';

  /** Whether the button is disabled */
  @Input() disabled = false;

  /** Whether the button text should be bold */
  @Input() bold = true;

  /** Event emitter that fires when the button is clicked */
  @Output() clicked = new EventEmitter<void>();

  /**
   * Handles button click event and emits the clicked event.
   */
  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
